import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function NoteAddIcon(props: IconProps) {
    return <Icon {...props} iconKey={"note_add"}/>
}
